'use strict';
angular.module('draftlistForWeiboModule', []).controller('draftlistForWeiboCtrl', draftlistForWeiboCtrl);
draftlistForWeiboCtrl.$inject = ['$scope', '$modalInstance', '$compile', 'weiboId', '$validation', 'trsHttpService', 'modalDialog', 'draftInfo', 'weiboApiParams', 'weiboApiService'];

/**
 * [draftlistForWeiboCtrl 微博发稿单控制器]
 *
 * @param   {[type]}  $scope          [$scope 当前作用域]
 * @param   {[type]}  $modalInstance  [$modalInstance 模态窗实例]
 * @param   {[type]}  $compile        [$compile 编译方法]
 * @param   {[type]}  weiboId         [weiboId 微博ID]
 * @param   {[type]}  $validation     [$validation 表单验证器]
 * @param   {[type]}  trsHttpService  [trsHttpService HTTP服务]
 * @param   {[type]}  modalDialog     [modalDialog 弹窗服务]
 * @param   {[type]}  draftInfo       [draftInfo 稿件信息]
 * @param   {[type]}  weiboApiParams       [draftInfo 稿件信息]
 * @param   {[type]}  weiboApiService       [draftInfo 稿件信息]
 *
 * @return  {[type]}                  [return description]
 */
function draftlistForWeiboCtrl($scope, $modalInstance, $compile, weiboId, $validation, trsHttpService, modalDialog, draftInfo, weiboApiParams, weiboApiService) {
    init();
    $scope.confirm = function() {
        $validation.validate($scope.draftForm.authorForm).success(function() {
            var fgdParams = {};
            //处理发稿单作者信息空数据提交问题
            if (
                angular.isDefined($scope.list.fgd_authinfo[0]) &&
                (!angular.isDefined($scope.list.fgd_authinfo[0].USERNAME) || $scope.list.fgd_authinfo[0].USERNAME === '')
            ) {
                $scope.list.fgd_authinfo = [];
            }
            //处理发稿单作者信息空数据提交问题
            fgdParams.FGD_EDITINFO = JSON.stringify(angular.copy($scope.list.fgd_editinfo));
            fgdParams.FGD_AUTHINFO = JSON.stringify(angular.copy($scope.list.fgd_authinfo));
            fgdParams.DOCGENRE = JSON.stringify($scope.list.DocGenre);
            fgdParams.ISNOPAYMENT = $scope.list.ISNOPAYMENT;
            $modalInstance.close(fgdParams);
        });
    };
    $scope.cancel = function() {
        $modalInstance.dismiss();
    };

    /**
     * [init 初始化]
     *
     * @return  {[type]}  [return description]
     */
    function init() {
        trsHttpService.httpServer('./editingCenter/properties/metadataEnum.json', '', 'get').then(function(data) {
            //初始化页面参数
            if (angular.isDefined(draftInfo)) {
                $scope.DOCGENRE = data.DocGenre;
                $scope.list = {
                    DocGenre: JSON.parse(draftInfo.DocGenre),
                    fgd_editinfo: JSON.parse(draftInfo.fgd_editinfo),
                    fgd_authinfo: JSON.parse(draftInfo.fgd_authinfo),
                    ISNOPAYMENT: JSON.parse(draftInfo.ISNOPAYMENT),
                };
                loadDirective();
            } else if (weiboId == 0) {
                $scope.DOCGENRE = data.DocGenre;
                $scope.list = {
                    DocGenre: angular.copy($scope.DOCGENRE[0]),
                    fgd_editinfo: [],
                    fgd_authinfo: [{ isCreate: true }],
                    ISNOPAYMENT: '1',
                };
                loadDirective();
            } else {
                $scope.DOCGENRE = data.DocGenre;
                let params = angular.extend({}, weiboApiParams.findFgdInfoParams, {
                    MicroContentId: weiboId,
                });
                $scope.loadingPromise = weiboApiService.findFgdById(params).then(function(data){
                    $scope.list = {
                        DocGenre: data.DOCGENRE,
                        fgd_editinfo: data.FGD_EDITINFO,
                        fgd_authinfo: data.FGD_AUTHINFO,
                        ISNOPAYMENT: data.ISNOPAYMENT,
                    };
                    loadDirective();
                });
            }
        });

        /**
         * [loadDirective 动态加载发稿单指令]
         *
         * @return  {[type]}  [return description]
         */
        function loadDirective() {
            var draftList =
                '<editor-dir list="list"  meta-data-id="{{metaDataId}}" editor-json="list.fgd_editinfo"></editor-dir>' +
                '<editor-auth-dir author="list.fgd_authinfo"></editor-auth-dir>';
            draftList = $compile(draftList)($scope);
            $($(angular.element(document)).find('editor')).append(draftList);
        }
    }
}
